import React, { PropsWithChildren } from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

export default function FadeOut({
  children
}: PropsWithChildren<{}>) {

  return (
    <div className={cn(styles.wrapper, styles.fadeOut)}>
      {children}
    </div>
  )
}

